import styled, { css, keyframes } from 'styled-components'
import IconArrowRight from '../../assets/img/icon-arrow-right.svg'

const showMenu = keyframes`
  from {
    transform: translate3d(-100%, 0px, 0px);
  } to {
    transform: translate3d(0px, 0px, 0px);
  }
`

const showMenuClose = keyframes`
  from {
    opacity: 0;
    transform: translate3d(-600px, 0px, 0px);
  } to {
    opacity: 1;
    transform: translate3d(0px, 0px, 0px);
  }
`

const showModal = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`

export const Modal = styled.nav`
  ${({ active }) => css`
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    width: 100%;
    height: 100vh;
    display: block;
    left: 0;
    transition: all 1s;
    z-index: 900;
    cursor: auto;
    animation: ${showModal} 200ms;

    ${active &&
    css`
      display: block;
    `}
  `}
`

export const MenuMobileContent = styled.div`
  /* width: 80%; */
  width: 300px;
  height: 100vh;
  position: relative;
  z-index: 901;

  @media (max-width: 500px) {
    width: 70%;
  }
`

export const CloseModal = styled.div`
  background: #a71e26;
  padding: 10px;
  border: 0;
  position: absolute;
  right: -40px;
  cursor: pointer;
  animation: ${showMenuClose} 400ms;

  img {
    filter: brightness(250%);
    width: 20px;
    height: 20px;
  }
`

export const MenuMobileBox = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    height: 100%;
    cursor: auto;
    animation: ${showMenu} 400ms;
  `}
`

export const MenuMobileHeader = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.primary};
    color: ${theme.colors.white}
    border-top: 1px solid #bbbbbb;
    font-weight: bold;
    font-size: 18px;
    padding: 20px 20px;

  `}

  color: #fff;
`

export const Account = styled.div`
  background: #fafafa;
  padding: 15px 20px;
  border-bottom: 1px solid #eeeeee;
`

export const HeaderNavigationItemLink = styled.a`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    font-size: 14px;
    text-decoration: none;
    cursor: pointer;
    color: ${theme.colors.mediumGrey};

    transition: all 400ms;

    &:before {
        content: '';
        background: url(${IconArrowRight}) no-repeat;
        background-size: contain;
        width: 6px;
        height: 10px;
        position: absolute;
        transition: all 400ms;
        right: 20px;
      }
    }

    img {
      width: 28px;
      height: 28px;
      margin-right: 6px;
    }

    img.profile-img {
      width: 30px;
      margin-right: 6px;
      border-radius: 50%;
    }

    span {
      margin-left: 6px;
    }
  `}
`

export const LinkVoltar = styled.a`
  display: flex;
  align-items: center;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;

  img {
    margin-right: 16px;
    width: 6px;
    height: 10px;
  }
`

export const Wrapper = styled.div`
  padding: 24px;
  overflow-y: auto;
  max-height: 84vh;
  background-color: white;
`

export const ProfileMenuList = styled.ul`
  position: relative;
  list-style: none;
  display: block;

  hr {
    opacity: 0.3;
    margin-top: -4px;
    margin-bottom: 10px;
  }

  .diamante {
    margin-bottom: 12px;
  }

  li {
    margin-bottom: 20px;
    display: block;
    font-size: 15px;
    position: relative;
    transition: all 400ms ease-in-out;

    .link-back {
      padding-left: 30px;
      margin-bottom: 30px;

      &:before {
        left: 0;
        top: 4px;
        transform: rotate(-180deg);
        transform-origin: center center;
      }
    }

    .link-back:before {
      content: '';
      background: url(${IconArrowRight}) no-repeat;
      background-size: contain;
      width: 6px;
      height: 10px;
      position: absolute;
      transition: all 400ms;
      right: 0;
    }
  }
`

export const Tag = styled.div`
  ${({ theme, color }) => css`
    padding: 8px 12px 8px 16px;
    font-size: 14px;
    border-radius: 4px;
    color: #fff;
    background-color: #333;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    .text {
      display: flex;
      gap: 8px;
    }

    .arrow-right {
      height: 12px;
      filter: brightness(2);
    }
  `}
`

export const Category = styled.div``

export const CategoryMenuList = styled.ul`
  position: relative;
  list-style: none;
  display: block;

  /* &.isActive {
    display: block;
  } */
`
export const CategoryMenuItem = styled.li`
  ${({ theme }) => css`
    margin-bottom: 20px;

    a {
      display: block;
      font-size: 15px;
      position: relative;
      transition: ${theme.transition.default};

      &.link-back {
        padding-left: 30px;
        margin-bottom: 30px;

        &:before {
          left: 0;
          top: 4px;
          transform: rotate(-180deg);
          transform-origin: center center;
        }
      }

      &:before {
        content: '';
        background: url(${IconArrowRight}) no-repeat;
        background-size: contain;
        width: 6px;
        height: 10px;
        position: absolute;
        transition: all 400ms;
        right: 0;
      }
    }
  `}

  display: block;

  &.isActive {
    display: none;
  }
`

export const CategorySubmenuList = styled.ul`
  display: block;
  list-style: none;
  display: none;

  &.isActive {
    display: block;
  }
`

export const CategorySubmenuItem = styled.li`
  ${({ theme }) => css`
    margin-bottom: 20px;

    a {
      display: block;
      font-size: 15px;
      position: relative;
      transition: ${theme.transition.default};

      &.link-back {
        padding-left: 30px;
        margin-bottom: 30px;

        &:before {
          left: 0;
          top: 4px;
          transform: rotate(-180deg);
          transform-origin: center center;
        }

        &:before {
          content: '';
          background: url(${IconArrowRight}) no-repeat;
          background-size: contain;
          width: 6px;
          height: 10px;
          position: absolute;
          transition: all 400ms;
          right: 0;
        }
      }
    }
  `}
`
